import axios from 'axios';

const REACT_APP_EVENT_CLINIC_URL = process.env.REACT_APP_EVENT_CLINIC_URL; // 後端 API 基本位置

export const getClinicList = async (areaName?: string) => {
  try {
    const response = await axios.post(`${REACT_APP_EVENT_CLINIC_URL}`, {
      areaName: areaName || undefined,
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching clinic list:', error);
    throw error;
  }
};